import { jsxs as l, jsx as r } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ l(
  "svg",
  {
    width: "99",
    height: "100",
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r("rect", { width: "99", height: "100", rx: "49.5", fill: "#F2DFE1" }),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M60.8401 59.4432L60.84 59.4434C59.4226 61.1541 56.3061 64.3489 53.5079 67.1491C52.1162 68.5418 50.8149 69.8253 49.8613 70.7609C49.528 71.0879 49.2372 71.3724 49 71.604C48.7629 71.3724 48.4722 71.0879 48.1389 70.7609C47.1855 69.8254 45.8842 68.5418 44.4927 67.1492C41.6946 64.349 38.5781 61.154 37.1599 59.4432L37.1597 59.443C34.3813 56.0929 33 52.6503 33 48.4195C33 39.3261 40.1737 32 48.9646 32H49.0339C57.8264 32 65 39.3261 65 48.4195C65 52.6501 63.6174 56.0928 60.8401 59.4432Z",
          fill: "white",
          stroke: "var(--plac-primary-gray)",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ r(
        "ellipse",
        {
          cx: "48.9998",
          cy: "48.5",
          rx: "5.95",
          ry: "6.125",
          fill: "white",
          stroke: "var(--plac-primary-gray)",
          strokeWidth: "2"
        }
      ),
      /* @__PURE__ */ r("circle", { cx: "66", cy: "41", r: "10", fill: "var(--plac-status-error)" }),
      /* @__PURE__ */ r(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M67.25 35.375L66.8857 42.7566H65.1429L64.7786 35.375H67.25ZM66.9214 46.2811C66.7024 46.5103 66.3976 46.6249 66.0071 46.6249C65.6071 46.6249 65.2976 46.5128 65.0786 46.2887C64.8595 46.0645 64.75 45.7484 64.75 45.3404C64.75 44.9173 64.8571 44.5975 65.0714 44.3809C65.2857 44.1643 65.5976 44.056 66.0071 44.056C66.4024 44.056 66.7083 44.1668 66.925 44.3885C67.1417 44.6101 67.25 44.9274 67.25 45.3404C67.25 45.7384 67.1405 46.0519 66.9214 46.2811Z",
          fill: "white"
        }
      )
    ]
  }
);
export {
  e as PinAlertIllustration
};
//# sourceMappingURL=index.es497.js.map
